module.exports = __webpack_public_path__ + "assets/images/rbyearend-03.jpg?v=94aaeee1";